<script lang="ts" setup>
import { TableHeaderFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { i18n } from '@/i18n';
import { computed, ref } from 'vue';

type BackgroundColor = 'bg-default' | 'bg-secondary';

// props
const props = withDefaults(
  defineProps<{
    label?: string;
    textAlign?: string; // スロットに要素を渡す場合は、そちらに設定して投げてください
    fontSize?: TableHeaderFontSize;
    backgroundColor?: BackgroundColor;
  }>(),
  {
    label: '',
    textAlign: 'center',
    fontSize: 'fontSizeS',
    backgroundColor: 'bg-secondary',
  }
);

//text-align
const textAlign = ref(props.textAlign);

//fontSizeの切り替え
const fontSizeClass = computed(() => {
  return props.fontSize;
});

//fontSizeの切り替え
const bgColorClass = computed(() => {
  return props.backgroundColor;
});

// emits
const emits = defineEmits<{
  (e: 'onHover'): void;
  (e: 'onLeave'): void;
  (e: 'onClick'): void;
}>();

//変数
const t = i18n.t;
</script>

<template>
  <th
    :class="[fontSizeClass, bgColorClass]"
    class="header-cell"
    @mouseover="emits('onHover')"
    @mouseleave="emits('onLeave')"
    @click="emits('onClick')"
  >
    <template v-if="props.label">
      <div class="header-cell__content">
        <div class="header-cell__content--text">{{ t(props.label) }}</div>
        <slot />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </th>
</template>

<style lang="scss" scoped>
.header-cell {
  position: sticky;
  color: $textDefault;

  height: 36px;
  padding: 11px 8px;

  text-align: v-bind(textAlign);
  max-width: 224px;
  min-width: 32px;

  font-family: Noto Sans JP;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0;

  &__content {
    display: flex;
    flex-direction: row;
    justify-content: v-bind(textAlign);
    align-items: center;

    &--text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

/* フォントサイズ切り替え用のクラス */
.fontSizeSS {
  font-size: $fontSizeSS;
}

.fontSizeS {
  font-size: $fontSizeS;
}

.fontSizeM {
  font-size: $fontSizeM;
}

.fontSizeL {
  font-size: $fontSizeL;
}

.bg-default {
  background-color: $surfaceDefault;
}

.bg-secondary {
  background-color: $surfaceSecondary;
}
</style>
